'use strict';

const clientSideValidation = require('../components/clientSideValidation');
var { loadUrl } = require('../utils');

/**
 * Validates the form field on blur out event.
 * @returns {void}
 */
function validateOrderStatusFormOnBlur() {
    var textInputFields = '.order_status input, .order_status select';
    $('body').on('blur', textInputFields, function (event) {
        clientSideValidation.functions.handleOnBlur.apply(this, [event]);
    });
}

module.exports = {
    init: function () {
        $(document).on('click', '.order-status-login', function () {
            var orderStatus = document.getElementById('unique-id-orderstatus');
            $(document).trigger('login-modal-open', ['login_popupin', 'order_status']);
            $(orderStatus).modal('show').find('.modal-body').spinner()
                .start();
            loadUrl(orderStatus).then(function () {
                $.spinner().stop();
            });
        });
    },
    validateBISNBlur: validateOrderStatusFormOnBlur
};
